module.exports = __webpack_public_path__ + "img/ugent-logo-en.6de58fd3.svg";